import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 px-4 bg-brand-cream" data-id="element-82">
      <div className="max-w-3xl mx-auto" data-id="element-83">
        <div className="bg-white border-4 border-brand-gold/40 p-5 sm:p-6 rounded-xl text-center shadow-lg" data-id="element-84">
          <p className="text-xs sm:text-sm font-extrabold text-brand-petrol uppercase tracking-widest mb-2" data-id="element-85">
            YOUR INVESTMENT IS 100% PROTECTED
          </p>
          <div className="w-14 h-14 mx-auto bg-brand-petrol/10 rounded-full flex items-center justify-center mb-2" data-id="element-86">
            <ShieldCheck className="w-7 h-7 text-brand-petrol" data-id="element-87" />
          </div>
          <h3 className="text-xl sm:text-2xl font-serif font-extrabold text-brand-graphite mb-1 uppercase" data-id="element-88">
            7-Day Total Guarantee
          </h3>
          <p className="text-sm sm:text-base font-bold text-brand-rose mb-3 uppercase tracking-wide" data-id="element-89">
            Your money is 100% protected
          </p>
          <div className="text-sm sm:text-base text-brand-graphite/90 font-medium max-w-2xl mx-auto leading-snug" data-id="element-90">
            <p data-id="element-91">
              You have 7 full days to explore the 6 guides, apply the sequences
              in the studio, and evaluate the results. If you are not fully
              satisfied, we will refund 100% of your money. Zero risk for you,
              total commitment from us.
            </p>
          </div>
        </div>
      </div>
    </section>;
}